import { createRoot } from 'react-dom/client'
import { useEffect, useState } from 'react'
import './styles.css'
import { App } from './App'
import { Logo1am } from './Logo1am'

const SCENE_TAGS = ['On Midnight', 'By 1AM', 'Classic deck']

const SHOWCASE_CARDS = ['/brand/midnight-classic-card.svg', '/brand/cardano-classic-card.svg', '/img2_.png']

function EmailForm() {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState('idle')

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!email.includes('@')) return
    setStatus('success')
  }

  if (status === 'success') {
    return <span className="email-success">You&apos;re on the list.</span>
  }

  return (
    <form className="email-form" id="launch-dock" onSubmit={handleSubmit}>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email for waitlist"
        aria-label="Email address"
        required
      />
      <button type="submit">Join waitlist</button>
    </form>
  )
}

function Root() {
  const [isDark, setIsDark] = useState(false)

  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)')
    const syncTheme = () => setIsDark(media.matches)

    syncTheme()

    if (media.addEventListener) {
      media.addEventListener('change', syncTheme)
      return () => media.removeEventListener('change', syncTheme)
    }

    media.addListener(syncTheme)
    return () => media.removeListener(syncTheme)
  }, [])

  const toggleTheme = () => setIsDark((current) => !current)

  return (
    <div className="site-shell" data-theme={isDark ? 'dark' : 'light'}>
      <div className="site-grid" />
      <div className="canvas-shell" aria-hidden="true">
        <App dark={isDark} />
        <div className="canvas-vignette" />
      </div>

      <header className="site-header">
        <div className="header-inner">
          <div className="header-brand">
            <a className="brand-link" href="https://1am.xyz" target="_blank" rel="noopener noreferrer" aria-label="Open 1AM website">
              <Logo1am className="brand-logo" animated />
            </a>
            <span className="header-pill">1AM Gaming</span>
          </div>

          <div className="header-actions">
            <button className="theme-toggle" type="button" onClick={toggleTheme} aria-label="Toggle color theme">
              {isDark ? 'Light mode' : 'Dark mode'}
            </button>
          </div>
        </div>
      </header>

      <main className="stage-shell">
        <section className="stage">
          <div className="hero-copy">
            <div className="hero-kicker">
              <span className="status-dot" />
              <span>1AM x Midnight</span>
            </div>

            <h1>ZKTT</h1>
            <p className="hero-subtitle">A card game on Midnight by 1AM.</p>

            <div className="waitlist-panel">
              <span className="waitlist-label">Join the waitlist</span>
              <EmailForm />
            </div>

            <div className="scene-tags" aria-label="Product tags">
              {SCENE_TAGS.map((tag) => (
                <span className="scene-tag" key={tag}>
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <aside className="hero-showcase" aria-label="Midnight card previews">
            <div className="showcase-surface">
              <div className="showcase-orbit showcase-orbit--outer" aria-hidden="true" />
              <div className="showcase-orbit showcase-orbit--inner" aria-hidden="true" />
              <div className="showcase-stack">
                {SHOWCASE_CARDS.map((card, index) => (
                  <img className={`showcase-card showcase-card--${index + 1}`} key={card} src={card} alt="" />
                ))}
              </div>
            </div>
          </aside>
        </section>

        <div className="meta-corners" aria-label="Project details">
          <div className="meta-corner">
            <span>On Midnight</span>
            <span>By 1AM</span>
            <span>With Webisoft</span>
          </div>

          <div className="meta-corner meta-corner--links">
            <a className="meta-link" href="https://1am.xyz" target="_blank" rel="noopener noreferrer">
              1am.xyz
            </a>
            <a className="meta-link" href="https://midnight.network" target="_blank" rel="noopener noreferrer">
              Midnight
            </a>
          </div>
        </div>
      </main>
    </div>
  )
}

createRoot(document.getElementById('root')).render(<Root />)
